/**
 * الموارد البشرية (WALLIYO-0131), in Arabic. A faithful translation of hr.en.ts,
 * which is the source text.
 */
export const hrAr = {
  "hr.tabs.aria": "الموارد البشرية",
  "hr.tab.directory": "الدليل",
  "hr.tab.recruiting": "التوظيف",
  "hr.tab.employees": "الموظفون",
  "hr.tab.learning": "التعلّم",
  "hr.subTabs.aria": "الموظفون",
  "hr.sub.records": "الملفات",
  "hr.sub.joining": "الالتحاق",
  "hr.sub.timeOff": "إجازات الجميع",
  "hr.sub.performance": "الأداء",
  "hr.sub.payroll": "الرواتب",
  "hr.sub.reviews": "المراجعات",
  "hr.sub.leaving": "المغادرة",
  "hr.locked": "هذا التبويب مخصص للموارد البشرية.",
  "hr.notBuilt": "لم يُبنَ بعد.",
  "hr.notBuiltHelp": "هذا التبويب مُصمَّم وينتظر واجهته. لا شيء يضيع بتركه.",
  "directory.title": "الدليل",
  "directory.sub": "يمكن لأي شخص البحث عن أي شخص.",
  "directory.search": "ابحث عن شخص",
  "directory.searchHelp": "اسم، أو الرقم على بطاقته.",
  "directory.searchPlaceholder": "الاسم أو المعرّف",
  "directory.go": "بحث",
  "directory.clear": "عرض الجميع",
  "directory.loading": "جارٍ قراءة الدليل…",
  "directory.failed": "تعذّرت قراءة الدليل.",
  "directory.retry": "أعد المحاولة",
  "directory.none": "لا أحد هنا يطابق «{query}».",
  "directory.empty": "لا أحد مُدرج بعد.",
  "directory.count": "{shown} من {total}",
  "directory.more": "النتائج أكثر مما هو معروض. ضيّق البحث.",
  "directory.colName": "الاسم",
  "directory.colRoles": "الدور",
  "directory.colTeams": "الفرق",
  "directory.colManager": "المسؤول",
  "directory.open": "افتح",
  "directory.noRole": "لا دور بعد",
  "directory.noTeam": "لا فريق بعد",
  "directory.noManager": "لا مسؤول",
  "directory.leads": "يقوده",
  "directory.invited": "مدعو",
  "directory.back": "العودة إلى الدليل",
  "directory.identity": "من هو",
  "directory.uuid": "المعرّف",
  "directory.uuidHelp": "الرقم على بطاقته. لا يتغيّر أبدًا.",
  "directory.email": "البريد الإلكتروني",
  "directory.managerOn": "{name}، {team}",
  "directory.teammates": "كل من في فرقه",
  "directory.whereTheySit": "أين تقع هذه الشخصية",
  "directory.emailThem": "إرسال بريد إلكتروني",
  "directory.teammatesNone": "هو الشخص الوحيد في فرقه.",
  "directory.personFailed": "تعذّرت قراءة هذا الشخص.",
  "directory.viewOnly": "الدليل يعرض الهيكل فقط. ما يستطيع الشخص فعله موجود في الموظفين.",
  "hr.loading": "جارٍ القراءة…",
  "hr.failed": "تعذّرت قراءة ذلك.",
  "hr.retry": "أعد المحاولة",
  "joining.invite": "ادعُ شخصًا",
  "joining.invited.title": "الدعوات المعلّقة",
  "joining.invited.help": "لديهم معرّف بالفعل ولا يمكنهم الدخول حتى يضعوا كلمة مرور.",
  "joining.invited.none": "لا أحد ينتظر الالتحاق.",
  "joining.arrived.title": "التحقوا مؤخرًا",
  "joining.arrived.help": "كل من التحق خلال الثلاثين يومًا الماضية.",
  "joining.arrived.none": "لم يلتحق أحد خلال الثلاثين يومًا الماضية.",
  "joining.col.name": "الاسم",
  "joining.col.roles": "الدور",
  "joining.col.sent": "دُعي في",
  "joining.col.waiting": "ينتظر منذ",
  "joining.col.joined": "التحق في",
  "joining.today": "اليوم",
  "joining.waiting": "{days} يومًا",
  "joining.stale": "يستحق التذكير",

  // ── Leaving ──
  "leaving.who": "من يغادر",
  "leaving.whoHelp": "كل من لا يزال هنا، وكل من غادر بالفعل.",
  "leaving.pick": "اختر شخصًا",
  "leaving.alreadyLeft": "غادر بالفعل",
  "leaving.nobody": "اختر شخصًا لترى ما سيتركه رحيله خلفه.",
  "leaving.gone": "{name} غادر بالفعل. هذه هي الأطراف المتبقية.",
  "leaving.noReason": "لم يُذكر سبب",
  "leaving.teams.title": "الفرق التي يقودها",
  "leaving.teams.help":
    "في فريق بلا قائد لا أحد يعتمد الإجازات ولا يراجع أحدًا ولا يشهد على الصلاحيات — وهي حقيقة واحدة.",
  "leaving.teams.none": "لا يقود أي فريق.",
  "leaving.teams.col.team": "الفريق",
  "leaving.teams.col.others": "أشخاص آخرون",
  "leaving.teams.col.after": "بعد رحيله",
  "leaving.team.others": "{count} آخرين",
  "leaving.team.noLead": "لن يقوده أحد",
  "leaving.team.covered": "يقوده شخص آخر",
  "leaving.team.handOver": "تسليمه",
  "leaving.grants.title": "مُنح باسمه",
  "leaving.grants.help": "سحب الدور لا يمسّ هذا أبدًا. المنح بلا تاريخ انتهاء هو كيف يحتفظ من غادر بصلاحية.",
  "leaving.grants.none": "لم يُمنح شيء باسمه.",
  "leaving.grants.col.what": "ماذا",
  "leaving.grants.col.why": "لماذا",
  "leaving.grants.col.ends": "ينتهي",
  "leaving.grant.forever": "لا ينتهي أبدًا",
  "leaving.grant.until": "حتى",
  "leaving.grants.revoke": "اسحب هذه",
  "leaving.last.title": "الخطوة الأخيرة",
  "leaving.last.help":
    "التعطيل ينهي جلساته المفتوحة البالغة {sessions} ويمنعه من الدخول. لا يُحذف شيء مما فعله — السجل يذكره إلى الأبد — ويبقى مُدرجًا في فرقه حتى لا ينقص أحدًا شخص بصمت.",
  "leaving.last.deactivate": "تعطيل",
  "leaving.last.seeThem": "رؤيته في الدليل",

  // ── Records ──
  "records.find": "ابحث",
  "records.findPlaceholder": "الاسم أو البريد",
  "records.team": "الفريق",
  "records.role": "الدور",
  "records.any": "الكل",
  "records.dueReview": "{count} صلاحيات تحتاج مراجعة",
  "records.accessDueReview": "صلاحية تحتاج مراجعة",
  "records.none": "لا أحد يطابق ذلك.",
  "records.neverSeen": "لم يدخل قط",
  "records.col.person": "الشخص",
  "records.col.role": "الدور",
  "records.col.teams": "الفرق",
  "records.col.joined": "التحق في",
  "records.col.lastSeen": "آخر ظهور",

  // ── Time off ──
  "timeOff.ask": "اطلب إجازة",
  "timeOff.approve": "اعتمد",
  "timeOff.refuse": "ارفض",
  "timeOff.days": "{days} أيام",
  "timeOff.decidedBy": "قرّره {name}",
  "timeOff.col.who": "من",
  "timeOff.col.kind": "النوع",
  "timeOff.col.when": "متى",
  "timeOff.col.days": "الأيام",
  "timeOff.col.status": "الحالة",
  "timeOff.kind.annual": "إجازة سنوية",
  "timeOff.kind.sick": "إجازة مرضية",
  "timeOff.kind.unpaid": "بدون أجر",
  "timeOff.kind.parental": "إجازة والدية",
  "timeOff.kind.other": "أخرى",
  "timeOff.status.pending": "في الانتظار",
  "timeOff.status.approved": "معتمدة",
  "timeOff.status.refused": "مرفوضة",
  "timeOff.status.withdrawn": "مسحوبة",
  "timeOff.balance.title": "رصيدك",
  "timeOff.balance.none": "لم يحدّد أحد رصيدك بعد. الموارد البشرية تفعل ذلك في ملف توظيفك.",
  "timeOff.balance.allowance": "الرصيد",
  "timeOff.balance.taken": "المأخوذ",
  "timeOff.balance.pending": "المطلوب",
  "timeOff.balance.pendingHelp": "لم يُؤخذ، لكنه ليس متاحًا.",
  "timeOff.balance.left": "المتبقي",
  "timeOff.toDecide.title": "في انتظارك",
  "timeOff.toDecide.help": "أنت تقود فريقهم، فالقرار لك. العمل في الموارد البشرية ليس الأمر نفسه.",
  "timeOff.mine.title": "طلباتك",
  "timeOff.mine.none": "لم تطلب أي إجازة.",
  "timeOff.away.title": "الغائبون اليوم",
  "timeOff.away.none": "لا أحد غائب اليوم.",
  "timeOff.everybody.title": "الجميع",
  "timeOff.everybody.help": "ترى هذا لأنك في الموارد البشرية. القرار لقائد فريقهم.",
  "timeOff.form.title": "اطلب إجازة",
  "timeOff.form.kind": "النوع",
  "timeOff.form.from": "أول يوم",
  "timeOff.form.to": "آخر يوم",
  "timeOff.form.days": "الأيام",
  "timeOff.form.daysHelp": "كم يوم عمل يغطيه هذا.",
  "timeOff.form.reason": "السبب",
  "timeOff.form.submit": "أرسل الطلب",
  "timeOff.decide.title": "قرّر هذا الطلب",
  "timeOff.decide.approveNote": "قل لماذا تعتمده",
  "timeOff.decide.refuseNote": "قل لماذا ترفضه",
  "timeOff.decide.submit": "سجّل القرار",
  "timeOff.done": "طُلب {days} أيام. يقرّر ذلك قائد فريقك.",
  "timeOff.approvedDone": "تمت الموافقة على إجازة {name}.",
  "timeOff.refusedDone": "رُفض طلب {name}.",

  // ── Reviews ──
  "reviews.grants.title": "يستحق النظر الآن",
  "reviews.grants.help": "المنح ذو تاريخ انتهاء يسحب نفسه. هذه هي التي لا تفعل، وتلك التي يحملها من لم يعد هنا.",
  "reviews.grants.none": "لا شيء ممنوح بالاسم بلا تاريخ انتهاء.",
  "reviews.leads.title": "القادة الذين عليهم مراجعة فرقهم",
  "reviews.leads.help": "من يقود فريقهم نعرفه سلفًا — لا أحد بحاجة لأن يُقال له من يراجع من.",
  "reviews.leads.none": "لا أحد في الفرق يحمل شيئًا ممنوحًا بالاسم.",
  "reviews.col.who": "من",
  "reviews.col.what": "ماذا",
  "reviews.col.why": "لماذا",
  "reviews.col.concern": "المشكلة",
  "reviews.col.lead": "القائد",
  "reviews.col.team": "الفريق",
  "reviews.col.people": "الأشخاص",
  "reviews.col.neverEnding": "بلا نهاية",
  "reviews.concern.holderLeft": "غادر",
  "reviews.concern.neverEnds": "لا ينتهي أبدًا",
  "reviews.concern.neverUsed": "لم يُستخدم قط",
  "reviews.changedAt": "آخر تعديل {when}",
  "reviews.open": "افتح صلاحياته",

  // ── Payroll ──
  "payroll.month": "الشهر",
  "payroll.open": "افتح شهرًا",
  "payroll.close": "أغلق الشهر",
  "payroll.notOpen": "لم يُفتح هذا الشهر بعد.",
  "payroll.closedOn": "أُغلق في {when} بواسطة {name}",
  "payroll.hold": "علّق",
  "payroll.release": "حرّر",
  "payroll.lines.title": "ما يتقاضاه كل شخص",
  "payroll.lines.help": "مأخوذ من ملفات التوظيف كما كانت عند فتح الشهر. أي زيادة لاحقة لا تغيّر ما هنا.",
  "payroll.col.person": "الشخص",
  "payroll.col.gross": "الإجمالي",
  "payroll.col.contributions": "الاشتراكات",
  "payroll.col.net": "الصافي",
  "payroll.col.status": "الحالة",
  "payroll.status.ready": "جاهز",
  "payroll.status.held": "معلّق",
  "payroll.status.paid": "مدفوع",
  "payroll.total.people": "الأشخاص",
  "payroll.total.gross": "الإجمالي",
  "payroll.total.contributions": "الاشتراكات",
  "payroll.total.net": "الصافي",
  "payroll.missing.title": "لا أحد يعرف كم يتقاضى هؤلاء",
  "payroll.missing.help": "ملف توظيفهم لا يذكر إجماليًا، فلا يمكن للرواتب دفع أجرهم. سجّله قبل الشهر القادم.",
  "payroll.openForm.title": "افتح شهرًا",
  "payroll.openForm.month": "الشهر",
  "payroll.openForm.help":
    "كل ملف توظيف فيه إجمالي يحصل على سطر. الاشتراكات تبدأ من صفر: ما يُقتطع يعتمد على مكان الشخص، وليس لهذه الشاشة أن تخمّنه.",
  "payroll.openForm.submit": "افتح",
  "payroll.holdForm.title": "غيّر هذا السطر",
  "payroll.holdForm.hold": "علّقه",
  "payroll.holdForm.release": "حرّره",
  "payroll.closeForm.title": "أغلق الشهر",
  "payroll.closeForm.help": "كل سطر جاهز يصبح مدفوعًا. المعلّق يبقى معلّقًا، ولهذا عُلّق.",
  "payroll.closeForm.submit": "أغلق",
  "payroll.opened": "{month} مفتوح، بـ {count} سطرًا.",
  "payroll.held": "سطر {name} معلّق.",
  "payroll.released": "سيُدفع سطر {name}.",
  "payroll.closed": "أُغلق الشهر.",

  // ── Performance ──
  "performance.cycle": "الدورة",
  "performance.openCycle": "افتح دورة",
  "performance.noCycle": "لم تُفتح أي دورة بعد.",
  "performance.runs": "من {from} إلى {to}",
  "performance.write": "اكتبها",
  "performance.keepWriting": "تابع الكتابة",
  "performance.col.who": "من",
  "performance.col.reviewer": "المُقيِّم",
  "performance.col.status": "الحالة",
  "performance.col.outcome": "كيف سارت",
  "performance.status.notStarted": "لم تبدأ",
  "performance.status.inProgress": "قيد الكتابة",
  "performance.status.submitted": "أُرسلت",
  "performance.status.signedOff": "اعتُمدت",
  "performance.gap.noTeam": "في لا فريق",
  "performance.gap.noLead": "الفريق بلا قائد",
  "performance.gap.leadsOwn": "يقود فريقه بنفسه",
  "performance.toWrite.title": "في انتظارك",
  "performance.toWrite.help": "أنت تقود فريقهم، فالكتابة لك.",
  "performance.mine.title": "تقييمك",
  "performance.mine.none": "ليس لديك تقييم في هذه الدورة.",
  "performance.everybody.title": "الجميع",
  "performance.everybody.help": "ترى هذا لأنك في الموارد البشرية. الكتابة تبقى للمُقيِّم.",
  "performance.everybody.gaps": "{count} منها بلا من يكتبها. هذا شأن المؤسسة، لا شأن هذه الدورة.",
  "performance.form.title": "افتح دورة",
  "performance.form.name": "الاسم",
  "performance.form.opens": "أول يوم",
  "performance.form.closes": "آخر يوم",
  "performance.form.submit": "افتح",
  "performance.writeForm.title": "اكتب التقييم",
  "performance.writeForm.outcome": "كيف سارت",
  "performance.writeForm.outcomeHelp": "كلمة تختارها، لا درجة من خمسة.",
  "performance.writeForm.note": "ماذا حدث",
  "performance.writeForm.save": "احفظ للاحق",
  "performance.writeForm.send": "أرسل",
  "performance.opened": "{name} مفتوحة، بـ {count} تقييمًا.",
  "performance.saved": "حُفظ. لا يراه أحد حتى ترسله.",
  "performance.sent": "أُرسل. يمكن لـ {name} رؤيته الآن.",

  // ── Recruiting and Learning ──
  "recruiting.openJob": "افتح وظيفة",
  "recruiting.editJob": "عدّل",
  "recruiting.addCandidate": "أضف شخصًا",
  "recruiting.move": "قدّمه",
  "recruiting.none": "لم تُفتح أي وظيفة بعد.",
  "recruiting.noTeam": "بلا فريق",
  "recruiting.noCandidates": "لم يتقدّم أحد بعد.",
  "recruiting.liveCandidates": "{count} في السباق",
  "recruiting.col.candidate": "المرشّح",
  "recruiting.col.reach": "كيف تصل إليه",
  "recruiting.col.stage": "المرحلة",
  "recruiting.col.applied": "تقدّم في",
  "recruiting.stage.applied": "تقدّم",
  "recruiting.stage.screening": "الفرز",
  "recruiting.stage.interview": "المقابلة",
  "recruiting.stage.offer": "عرض مُرسَل",
  "recruiting.stage.hired": "عُيّن",
  "recruiting.stage.declined": "رُفض",
  "recruiting.stage.withdrawn": "انسحب",
  "recruiting.status.open": "مفتوحة",
  "recruiting.status.onHold": "موقوفة",
  "recruiting.status.filled": "مشغولة",
  "recruiting.status.closed": "مغلقة",
  "recruiting.jobForm.title": "افتح وظيفة",
  "recruiting.jobForm.name": "العنوان",
  "recruiting.jobForm.team": "الفريق",
  "recruiting.jobForm.noTeam": "بلا فريق بعد",
  "recruiting.jobForm.description": "ما هي الوظيفة",
  "recruiting.jobForm.status": "الحالة",
  "recruiting.jobForm.submit": "افتح",
  "recruiting.candidateForm.title": "أضف شخصًا",
  "recruiting.candidateForm.name": "الاسم",
  "recruiting.candidateForm.phone": "الهاتف",
  "recruiting.candidateForm.email": "البريد",
  "recruiting.candidateForm.note": "ما يستحق المعرفة",
  "recruiting.candidateForm.submit": "أضِف",
  "recruiting.moveForm.title": "قدّمه",
  "recruiting.moveForm.stage": "المرحلة",
  "recruiting.moveForm.hired": "وسم شخص كمُعيَّن يسجّل أنه عُيّن. دعوته تتم في الالتحاق، حيث توجد بالفعل.",
  "recruiting.moveForm.submit": "قدّمه",
  "recruiting.jobOpened": "{title} مفتوحة.",
  "recruiting.jobEdited": "حُدّثت {title}.",
  "recruiting.candidateAdded": "{name} في القائمة.",
  "recruiting.candidateMoved": "{name} الآن في {stage}.",
  "learning.addCourse": "أضف دورة",
  "learning.enrol": "سجّل",
  "learning.continue": "تابع",
  "learning.finish": "أنهِ",
  "learning.alreadyEnrolled": "مُسجَّل",
  "learning.requiredBy": "مطلوبة لـ {permission} — أنهِها قبل المنح، لا بعده.",
  "learning.requiredOfAll": "إلزامية للجميع",
  "learning.anybody": "مفتوحة للجميع",
  "learning.minutes": "{minutes} د",
  "learning.enrolled": "{count} مسجّلين",
  "learning.hrOnly": "للموارد البشرية فقط",
  "learning.mine.title": "مطلوبة منك",
  "learning.mine.help": "الدورة المرتبطة بصلاحية يجب إنهاؤها قبل منح الصلاحية.",
  "learning.mine.none": "لا شيء مطلوب منك الآن.",
  "learning.catalogue.title": "الفهرس",
  "learning.catalogue.help": "مفتوح للجميع. التسجيل لا يحتاج إذن أحد — المنح خلف الدورة هو ما يحتاجه.",
  "learning.byTeam.title": "على مستوى الشركة",
  "learning.byTeam.help": "من لا يزال مدينًا بالدورات الإلزامية. المتابعة على قائد الفريق.",
  "learning.col.course": "الدورة",
  "learning.col.status": "الحالة",
  "learning.col.progress": "التقدّم",
  "learning.col.team": "الفريق",
  "learning.col.people": "الأشخاص",
  "learning.col.done": "منتهية",
  "learning.status.enrolled": "مُسجَّل",
  "learning.status.inProgress": "جارية",
  "learning.status.done": "منتهية",
  "learning.courseForm.title": "أضف دورة",
  "learning.courseForm.name": "العنوان",
  "learning.courseForm.audience": "لمن",
  "learning.courseForm.minutes": "كم تستغرق، بالدقائق",
  "learning.courseForm.required": "مطلوبة لصلاحية",
  "learning.courseForm.requiredHelp": "معرّف إعداد الصلاحية التي تُعدّ هذه الدورة شرطًا لها.",
  "learning.courseForm.everybody": "إلزامية للجميع",
  "learning.courseForm.submit": "أضِف",
  "learning.courseAdded": "{title} في الفهرس.",
  "learning.enrolledDone": "سُجّلت في {title}.",
  "learning.finished": "انتهت {title}.",

  // ── Alerts and refusals ──
  "alert.dismiss": "إغلاق",
  "error.reason.permission_not_held": "دورك يفتح هذه الشاشة، لا هذا الإجراء. اطلبه ممن يستطيع منحه.",
  "error.reason.not_found": "لم يعد هذا موجودًا. أعد التحميل وحاول مجددًا.",
  "error.reason.no_reason": "قل لماذا، بكلمات قليلة.",
  "error.reason.name_taken": "هذا الاسم مأخوذ بالفعل.",
  "error.reason.team_closed": "هذا مغلق. أعد فتحه قبل إضافة أحد.",
  "error.reason.staff_deactivated": "غادر هذا الشخص فلا يمكن إضافته.",
  "error.reason.lead_must_be_member": "لا يقود المرء إلا فريقًا هو فيه.",
  "error.reason.duplicate_change": "الشخص نفسه يظهر مرتين. أرسله مرة واحدة.",
  "error.reason.own_request": "لا يمكنك البتّ في إجازتك أنت.",
  "error.reason.not_their_lead": "من يقود فريقهم وحده يقرّر هذا. العمل في الموارد البشرية ليس الأمر نفسه.",
  "error.reason.already_decided": "تم البتّ في هذا سلفًا. أعد التحميل لترى كيف.",
  "error.reason.backwards": "آخر يوم قبل أول يوم.",
  "error.reason.too_long": "هذا أطول مما يغطيه طلب واحد.",
  "error.reason.month_open": "هذا الشهر مفتوح بالفعل.",
  "error.reason.already_paid": "دُفع هذا السطر. الشهر المغلق هو ما دُفع.",
  "error.reason.already_closed": "هذا الشهر مغلق بالفعل.",
  "error.reason.nobody_payable": "لا ملف توظيف يحمل إجماليًا مسجَّلًا.",
  "error.reason.invalid_month": "اكتب الشهر بصيغة سنة-شهر.",
  "error.reason.own_review": "لا يمكنك كتابة تقييمك أنت.",
  "error.reason.not_the_reviewer": "طُلب من شخص آخر كتابته.",
  "error.reason.signed_off": "اعتُمد هذا التقييم.",
  "error.reason.no_outcome": "قل كيف سارت قبل الإرسال.",
  "error.reason.job_closed": "هذه الوظيفة مغلقة. أعد فتحها قبل إضافة أحد.",
  "error.reason.candidate_out": "لم يعد هذا الشخص في السباق. أضِفه مجددًا إن عاد.",
  "error.reason.title_taken": "هذا العنوان مأخوذ بالفعل.",
  "error.reason.course_retired": "لم تعد هذه الدورة تُقدَّم.",
  "error.reason.invalid_progress": "التقدّم نسبة مئوية صحيحة، من 0 إلى 100.",

  // ── Roles: what a role covers ──
  "roles.covers.everything": "كل شيء",
  "roles.covers.features": "{count} ميزة",
  "roles.covers.permissions": "{count} صلاحية",
  "roles.covers.critical": "{count} حرجة",
  "roles.covers.high": "{count} عالية",
  "roles.covers.seeAll": "عرض الـ {count} كلها",
  "roles.covers.permissionsHeading": "الصلاحيات",

  // ── Roles, redesigned ──
  "roles.band.critical": "أدوار تستطيع تقرير ما يفعله أي أحد",
  "roles.band.people": "أشخاص يحملون أحدها",
  "roles.band.total": "أدوار في المجمل",
  "roles.band.unheld": "لا يحملها أحد",
  "roles.reach.critical": "حرج",
  "roles.reach.high": "عالٍ",
  "roles.reach.low": "منخفض",
  "roles.rail.people": "{count} أشخاص",
  "roles.rail.unheld": "لا أحد يحمله",
  "roles.noDescription": "بلا وصف",
  "roles.figure.people": "الأشخاص",
  "roles.figure.features": "الميزات",
  "roles.figure.permissions": "الصلاحيات",
  "roles.figure.critical": "الحرجة",
  "roles.block.holders": "من يحمله",
  "roles.block.holdersHelp": "إعطاء هذا الدور لشخص يعطيه كل ما يلي.",
  "roles.block.holdersNone": "لا أحد يحمل هذا الدور.",
  "roles.block.give": "أعطه لشخص",
  "roles.block.take": "اسحبه",
  "roles.block.grants": "ما يمنحه",
  "roles.block.grantsHelp": "إلى أين يصل، حسب المجال.",
  "roles.block.criticalWarning": "من يحمل هذا الدور يستطيع تقرير ما يفعله أي شخص آخر.",
  "roles.block.change": "غيّر ما يمنحه",
  "roles.block.opens": "ما يفتحه",
  "roles.block.opensHelp": "محسوب من الميزات أعلاه، لا يُخزَّن أبدًا — والقائمة تسأل الدالة نفسها.",
  "roles.block.opensNone": "لا يفتح أي شاشة بمفرده.",
  "roles.block.compare": "مقارنًا بـ",
  "roles.block.compareWith": "قارن بـ",
  "roles.compare.only": "{count} هنا فقط",
  "roles.compare.theirs": "{count} هناك فقط",
  "roles.compare.shared": "{count} مشتركة",
  "roles.give.title": "أعطِ هذا الدور لشخص",
  "roles.give.who": "لمن",
  "roles.give.submit": "أعطه",
  "roles.give.done": "{name} يحمل الآن {role}.",
  "roles.take.title": "اسحب هذا الدور",
  "roles.take.body": "يحتفظ بكل أدواره الأخرى.",
  "roles.take.submit": "اسحبه",
  "roles.take.done": "{name} لم يعد يحمل {role}.",
  "roles.holdersUnknown": "تعذّرت القراءة",
  "roles.compare.same": "يمنحان الميزات نفسها تمامًا.",
  "roles.notice.critical": "{roles} منها تستطيع تقرير ما يفعله أي أحد — {people} أشخاص يحملون أحدها.",
  "roles.notice.criticalOnly": "{roles} منها تستطيع تقرير ما يفعله أي أحد.",
  "roles.notice.unheld": "{count} لا يحملها أحد.",

  // ── Actions, by person ──
  "actions.find": "ابحث عن شخص",
  "actions.matches": "من تقصد؟",
  "actions.findPlaceholder": "الاسم أو المعرّف",
  "actions.nobody": "ابحث عن شخص لترى ما يستطيع فعله.",
  "actions.noRoles": "بلا دور",
  "actions.col.on": "مُفعَّل",
  "actions.col.source": "المصدر",
  "actions.col.reason": "السبب",
  "actions.mustAsk": "عليه أن يطلب فوق {limit}",
  "actions.clear": "امسح",
  "actions.until": "حتى {when}",
  "actions.onlyOverrides":
    "لا يوجد على هذا الشخص سوى استثناء واحد، وهو الوحيد الذي تستطيع هذه الشاشة سحبه. كل ما عداه يأتي من دور أو من طريقة تسليم الإجراء — غيّرها حيث توجد.",
  "actions.blocked.permission": "لديه الميزة، لا الصلاحية التي يتطلبها هذا الإجراء.",
  "actions.locked.noFeature": "مفتوح للجميع: لا مفتاح خلفه.",
  "actions.view.catalogue": "الفهرس",
  "actions.view.person": "حسب الشخص",
  "actions.notWiredYet": "التفعيل غير موصول بعد. استخدم الميزات والصلاحيات في الوقت الحالي.",
  "actions.view.role": "حسب الدور",
  "actions.pickRole": "الدور",

  // ── Switching an action ──
  "actions.switch.onTitle": "فعّل",
  "actions.switch.offTitle": "عطّل",
  "actions.switch.clearTitle": "امسح",
  "actions.switch.submit": "فعّل",
  "actions.switch.writes": "هذا يكتب الميزة التي خلفه: {feature}.",
  "actions.switch.alsoMoves": "تلك الميزة تفتح أيضًا {count} إجراءات أخرى تتحرك معها: {actions}.",
  "actions.switch.permissionToo": "ستظل الصلاحية التي تحرس هذا الإجراء ناقصة. امنحها من الصلاحيات.",
  "actions.switch.switchedOn": "{action} مُفعَّل لـ {who}.",
  "actions.switch.switchedOff": "{action} مُعطَّل لـ {who}.",
  "actions.switch.cleared": "عاد {action} إلى ما يرثه.",
  "actions.pending": "لم يُحفظ بعد",
  "actions.saved": "حُفظ {count} مفاتيح.",
} as const;
